"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeBodyLayout = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../helpers");
const GrowView_1 = require("../GrowView");
const TreeBodyLayout_styles_1 = require("./TreeBodyLayout.styles");
function TreeBodyLayout({ toolbar, style, className, fragment, tree, ['data-selector-id']: dataSelectorId }) {
    return (react_1.default.createElement(GrowView_1.GrowView, { "data-tree-body-layout": true, style: style, "data-selector-id": dataSelectorId, className: (0, helpers_1.cn)('vm-TreeBodyLayout', className) },
        toolbar && (react_1.default.createElement(TreeBodyLayout_styles_1.StyledTreeBodyLayoutToolbarSlot, null, toolbar)),
        react_1.default.createElement(TreeBodyLayout_styles_1.StyledTreeBodyLayoutTreeSlot, null, tree),
        !!fragment && (react_1.default.createElement(TreeBodyLayout_styles_1.StyledTreeBodyLayoutFragmentSlot, null, fragment))));
}
exports.TreeBodyLayout = TreeBodyLayout;
//# sourceMappingURL=TreeBodyLayout.js.map